import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: About / Quick Links */}
        <div className="footer-column">
          <h3>गट ग्रामपंचायत गावसुत</h3>
          <p>पंचायत समिती उमरेड, जि. नागपूर</p>
          <p>ISO 9001:2015 प्रमाणित</p>
          <ul className="quick-links">
            <li><a href="/aboutus">ग्रामपंचायत बद्दल</a></li>
            <li><a href="/devlopment">विकास कामे</a></li>
            <li><a href="/gallery">छायाचित्र</a></li>
            <li><a href="/contact">संपर्क</a></li>
          </ul>
        </div>

        {/* Column 2: Social Media */}
        <div className="footer-column social-column">
          <h3>आम्हाला फॉलो करा</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <img src="/images/facebook.png" alt="Facebook" className="social-icon" />
            </a>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="X">
              <img src="/images/twitter.png" alt="X" className="social-icon" />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <img src="/images/instagaram.jpg" alt="Instagram" className="social-icon" />
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <img src="/images/youtube.png" alt="YouTube" className="social-icon" />
            </a>
          </div>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-column contact-column">
          <h3>संपर्क</h3>
          <p>ग्रामपंचायत कार्यालय</p>
          <p><strong>8888769440 | 9960473271</strong></p>
          <p>  Helpline No:  (तांत्रिक मदत:) 9975977462</p>
        </div>
 
        {/* Column 4: Government Logos */}
        <div className="footer-column logos-column">
          <h3>सरकारी दुवे</h3>
          <div className="gov-logos">
            <a href="https://swachhbharat.mygov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/swachh-bharat.png" alt="Swachh Bharat" />
            </a>
            <a href="https://digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/digital-india-logo.png" alt="Digital India" />
            </a>
            <a href="https://data.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/portal.jpg" alt="Open Government Data" />
            </a>
            <a href="https://www.india.gov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/mh_logo.png" alt="National Portal" />
            </a>
            <a href="https://www.mygov.in/" target="_blank" rel="noopener noreferrer">
              <img src="/images/mygov.png" alt="MyGov" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Compact Credit */}
      <div className="footer-bottom">
        <div className="credit">
          Website Designed & Maintained by <strong>certnexus India Pvt. Ltd., Nagpur</strong><br />
          
        </div>
      </div>

      <style>{`
        .footer {
          background: linear-gradient(to bottom, #2e3134, #4e5358);
          color: #ffffff;
          padding: 45px 20px 25px;   /* Height कमी करण्यासाठी padding कमी केले */
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .footer-container {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
          gap: 35px;                 /* Gap थोडा कमी */
        }

        .footer-column h3 {
          font-size: 1.35rem;
          margin-bottom: 16px;
          color: #a8daf9;
          font-weight: 700;
        }

        .footer-column p {
          font-size: 0.98rem;
          margin: 6px 0;
          opacity: 0.9;
        }

        .quick-links {
          list-style: none;
          padding: 0;
          margin-top: 12px;
        }

        .quick-links li {
          margin: 8px 0;
        }

        .quick-links a {
          color: #a8daf9;
          text-decoration: none;
          transition: color 0.3s;
        }

        .quick-links a:hover {
          color: #ffffff;
          text-decoration: underline;
        }

        .social-icons {
          display: flex;
          justify-content: center;
          gap: 18px;
          flex-wrap: wrap;
        }

        .social-icon {
          width: 38px;
          height: 38px;
          transition: transform 0.3s;
        }

        .social-icon:hover {
          transform: scale(1.18);
        }

        .gov-logos {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 18px;
        }

        .gov-logos img {
          height: 52px;
          width: auto;
          transition: transform 0.3s;
        }

        .gov-logos img:hover {
          transform: scale(1.08);
        }

        .footer-bottom {
          margin-top: 40px;
          padding-top: 25px;
          border-top: 1px solid rgba(255,255,255,0.15);
          text-align: center;
          font-size: 0.92rem;
          opacity: 0.88;
        }

        .credit strong {
          color: #a8daf9;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .footer {
            padding: 35px 15px 20px;
          }
          .footer-container {
            gap: 30px;
          }
          .gov-logos img {
            height: 48px;
          }
        }

        @media (max-width: 480px) {
          .footer-column h3 {
            font-size: 1.25rem;
          }
          .social-icon {
            width: 34px;
            height: 34px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;